import * as React from 'react';
import classNames from 'classnames';
import './Line.scss';

export interface ILineProps {
  className?: string;
}

const Line = ({ className }: ILineProps) => (
  <div className={classNames('line', className)} />
);

export default Line;



// WEBPACK FOOTER //
// ./src/components/Line/index.tsx